import api from "../api";
import moment from "moment"
import * as CONSTANTS from "@/store/constants";

export default {
    methods: {
        async getAllBookmarks(offset) {
            let bookmarks = await api.getBookmarks(offset);
            return bookmarks.data;
        }, 
        

        getBookmarkTarget(url) {
            let header = this.$root.$children[0].$refs.header.getVueInstance();
            return header.getAoneLinkTarget(url);
        },

        filterBookmarks(formattedbookmarks) {
            return formattedbookmarks.filter(b => b.title && b.title.length > 0);
        }

    }
}



// WEBPACK FOOTER //
// ./src/mixins/AutodeskOneBookmarksMixin.js